import { Card, Heading, HStack, Icon, LinkBox, LinkOverlay, Spacer, Stack, Text, useToken } from '@chakra-ui/react'
import type { FC } from 'react'
import { PiEnvelopeSimpleLight } from 'react-icons/pi'
import { Link, useParams } from 'react-router-dom'

import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import Slack from '@app/images/slack'
import type { DashboardItem } from '@app/pages/aiDashboard/types'

interface Props {
  report: DashboardItem
}

const AIDashboardReportListItem: FC<Props> = ({ report }) => {
  const [disabledIconColor, activeIconColor] = useToken('colors', ['gray.500', 'blue.500'])
  const schedule = useGetObjectsByProperties('schedule', {
    schedulableType: 'RecurringReportConfiguration',
    schedulableId: report.id
  })?.[0]
  const { recurringReportId } = useParams()

  return (
    <LinkBox as="article">
      <Card.Root
        size="sm"
        cursor="pointer"
        borderColor={report.id === recurringReportId ? 'blue.300' : 'inherit'}
        _hover={{ borderColor: 'border.inverted' }}
        transition="border-color 0.2s ease-in-out"
      >
        <Card.Header>
          <Heading size="md">
            <LinkOverlay asChild>
              <Link to={`${report.id}/current`}>{report.name}</Link>
            </LinkOverlay>
          </Heading>
        </Card.Header>
        <Card.Body color="fg.muted">
          <Stack gap={2}>
            <Text fontSize="sm" lineClamp={3}>
              {report.aiPrompt}
            </Text>
          </Stack>
        </Card.Body>
        <Card.Footer>
          <HStack w="full">
            <Text fontSize="xs">{schedule?.humanized || ''}</Text>

            <Spacer />
            <Text>
              {report.sendToEmail ? (
                <Icon boxSize={4}>
                  <PiEnvelopeSimpleLight color={activeIconColor} />
                </Icon>
              ) : (
                <Icon boxSize={4}>
                  <PiEnvelopeSimpleLight color={disabledIconColor} />
                </Icon>
              )}
            </Text>
            <Text>
              {report.sendToSlack ? (
                <Icon boxSize={3}>
                  <Slack />
                </Icon>
              ) : (
                <Icon boxSize={3}>
                  <Slack color={disabledIconColor} />
                </Icon>
              )}
            </Text>
          </HStack>
        </Card.Footer>
      </Card.Root>
    </LinkBox>
  )
}

export default AIDashboardReportListItem
